import styled, { keyframes } from "styled-components";

import { radii } from "shared/ui/tokens";

const shimmer = keyframes`
    0% { background-position: 100% 0; }
    100% { background-position: -100% 0; }
`;

export const Block = styled.div<{ $width?: string; $height?: string; $radius?: string }>`
    width: ${({ $width }) => $width || "100%"};
    height: ${({ $height }) => $height || "16px"};
    border-radius: ${({ $radius }) => $radius || radii.small};
    background: linear-gradient(
        90deg,
        rgba(0, 0, 0, 0.04) 25%,
        rgba(0, 0, 0, 0.07) 37%,
        rgba(0, 0, 0, 0.04) 63%
    );
    background-size: 200% 100%;
    animation: ${shimmer} 1.4s ease-in-out infinite;
`;
